module.exports = __webpack_public_path__ + "static/has-signup-btn.87b193bb.png";